import { DisplayProperties } from '@com-delta-omnichannel/aura';
import {
  SimplePaginator10Mocks,
  SimplePaginator11Mocks,
  SimplePaginator12Mocks,
  SimplePaginator13Mocks,
  SimplePaginator2Mocks,
  SimplePaginator3Mocks,
  SimplePaginator4Mocks,
  SimplePaginator5Mocks,
  SimplePaginator6Mocks,
  SimplePaginator7Mocks,
  SimplePaginator8Mocks,
  SimplePaginator9Mocks,
  SimplePaginatorMocks
} from '../components/simple-paginator/mocks/simple-paginator.mocks';
import { CardCarousel } from '../models/card-carousel.interfaces';
import {
  CardMultiple10Mocks,
  CardMultiple11Mocks,
  CardMultiple12Mocks,
  CardMultiple13Mocks,
  CardMultiple2Mocks,
  CardMultiple3Mocks,
  CardMultiple4Mocks,
  CardMultiple5Mocks,
  CardMultiple6Mocks,
  CardMultiple7Mocks,
  CardMultiple8Mocks,
  CardMultiple9Mocks,
  CardSingleMocks
} from './card.mocks';

export const CardCarouselSingleMocks: CardCarousel = {
  cards: CardSingleMocks,
  paginator: SimplePaginatorMocks,
  current: 1,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple2Mocks: CardCarousel = {
  cards: CardMultiple2Mocks,
  paginator: SimplePaginator2Mocks,
  current: 2,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple3Mocks: CardCarousel = {
  cards: CardMultiple3Mocks,
  paginator: SimplePaginator3Mocks,
  current: 3,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple4Mocks: CardCarousel = {
  cards: CardMultiple4Mocks,
  paginator: SimplePaginator4Mocks,
  current: 4,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple5Mocks: CardCarousel = {
  cards: CardMultiple5Mocks,
  paginator: SimplePaginator5Mocks,
  current: 5,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple6Mocks: CardCarousel = {
  cards: CardMultiple6Mocks,
  paginator: SimplePaginator6Mocks,
  current: 6,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple7Mocks: CardCarousel = {
  cards: CardMultiple7Mocks,
  paginator: SimplePaginator7Mocks,
  current: 7,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple8Mocks: CardCarousel = {
  cards: CardMultiple8Mocks,
  paginator: SimplePaginator8Mocks,
  current: 8,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple9Mocks: CardCarousel = {
  cards: CardMultiple9Mocks,
  paginator: SimplePaginator9Mocks,
  current: 9,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple10Mocks: CardCarousel = {
  cards: CardMultiple10Mocks,
  paginator: SimplePaginator10Mocks,
  current: 10,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple11Mocks: CardCarousel = {
  cards: CardMultiple11Mocks,
  paginator: SimplePaginator11Mocks,
  current: 11,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple12Mocks: CardCarousel = {
  cards: CardMultiple12Mocks,
  paginator: SimplePaginator12Mocks,
  current: 12,
  disabled: false,
  loaded: true
};

export const CardCarouselMultiple13Mocks: CardCarousel = {
  cards: CardMultiple13Mocks,
  paginator: SimplePaginator13Mocks,
  current: 13,
  disabled: false,
  loaded: true
};

export const cardsBannerMock: CardCarousel = {
  cards: [
    {
      image: {
        alt: 'Delta SkyMiles Reserve Card',
        position: 'right',
        show: true,
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-reserve-card.png'
      },
      labels: {
        subtitle: '',
        title: 'Delta SkyMiles® Reserve Card Member'
      }
    }
  ],
  current: 1,
  disabled: false,
  loaded: true,
  paginator: {
    ariaLabels: {
      indicator: 'Card (1/1)',
      next: 'Next Arrow',
      previous: 'Previous Arrow'
    },
    current: 1,
    label: 'Card (1/1)',
    total: 1
  }
};

export const cardsBannerErrorMock: DisplayProperties = {
  disabled: true,
  loaded: true,
  error: undefined
};
